import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useRef,
  useEffect,
} from 'react';
import TagEditor from 'components/ui/TagEditor';
import Constants from 'constants/AdminConstants';
import { mapTags } from 'utils/formatters/tags';

export default forwardRef((props, ref) => {
  const { value, stopEditing, data, onShipmentChangeTags } = props;
  const [tags, setTags] = useState(mapTags(value));
  const isMounted = useRef(null);
  const wrapperRef = useRef(null);

  const onChange = async (data, tags) => {
    try {
      await onShipmentChangeTags(data, tags);
      if (isMounted.current) {
        setTags(tags);
      }
      stopEditing();
    } catch (e) {
      console.error(e);
    }
  };

  useImperativeHandle(ref, () => {
    return {
      getValue() {
        return tags;
      },
    };
  });

  useEffect(() => {
    isMounted.current = true;
    // Function to handle clicks outside the editor
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        stopEditing();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      isMounted.current = false; // Set to false when component unmounts
    };
  }, []);

  return (
    <div ref={wrapperRef} className="px-4 py-5 sm:p-6 bg-white">
      <TagEditor
        client="edi-settings"
        object={data}
        tags={tags}
        suggestions={Constants.shipmentTagSuggestions}
        handleChange={onChange}
        hideLabel={false}
        wrapperClasses="mb-0 min-w-40"
      />
    </div>
  );
});
